module.exports = __webpack_public_path__ + "img/10-montreal.fae9251e.png";